import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  // useNewsletter
  newsletterInvalidEmail: {
    id: 'portal.hooks.utils.newsletter.invalidEmail',
    defaultMessage: 'Please enter valid email',
    description: 'Newsletter: invalid email message',
  },
  newsletterFailedMessage: {
    id: 'portal.hooks.utils.newsletter.failed.message',
    defaultMessage: 'Failed to subscribe to newsletter',
    description: 'Newsletter: failed to subscribe message',
  },
  newsletterSuccessMessage: {
    id: 'portal.hooks.utils.newsletter.success.message',
    defaultMessage: 'Successfully subscribed to the newsletter.',
    description: 'Newsletter: success message',
  },
});

export default messages;
